document.addEventListener("DOMContentLoaded", function () {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    document.querySelectorAll(".wishlist-icon").forEach((icon) => {
        let productHandle = icon.getAttribute("data-handle");

        // Change heart color if product is already in wishlist
        if (wishlist.includes(productHandle)) {
            icon.querySelector("path").setAttribute("fill", "red");
            icon.querySelector("path").setAttribute("stroke", "red");
        }

        icon.addEventListener("click", function () {
            let index = wishlist.indexOf(productHandle);

            if (index === -1) {
                // Add to wishlist
                wishlist.push(productHandle);
                icon.querySelector("path").setAttribute("fill", "red");
                icon.querySelector("path").setAttribute("stroke", "red");
            } else {
                // Remove from wishlist
                wishlist.splice(index, 1);
                icon.querySelector("path").setAttribute("fill", "none");
                icon.querySelector("path").setAttribute("stroke", "black");
            }

            localStorage.setItem("wishlist", JSON.stringify(wishlist));
        });
    });
});


